import { useEffect, useState } from "react";
import { useListingModalPlanOptionsContext } from "../../components/training-plan/material";
import { Listing } from "../../interfaces/training-plan/Listing";

type UseOnetimeButVerifyPurchase = {
  currentListing: Listing;
};

export const useOnetimeBuyVerifyPurchase = ({
  currentListing,
}: UseOnetimeButVerifyPurchase) => {
  const [isPurchased, setIsPurchased] = useState(false);
  const { handleGetOwnedListings } = useListingModalPlanOptionsContext();

  useEffect(() => {
    const handleVerifyOnetimePurchase = async () => {
      const ownedListings = await handleGetOwnedListings();
      const ownedListing = ownedListings.rows.find(
        (item) => item.id === currentListing.id,
      );

      if (ownedListing) {
        setIsPurchased(true);
      } else {
        setIsPurchased(false);
      }
    };
    void handleVerifyOnetimePurchase();
  }, [currentListing.id, handleGetOwnedListings]);

  return isPurchased;
};
